import { Permission } from '@boxoffice/wmp-common/config/permission';
import { FeatureFlag } from '@boxoffice/wmp-common/domains/acl/types';

const CONFIGURATION_FILE = `/config.json`;
const OVERRIDE_CONFIGURATION_FILE = '/override.json';

export type Config = Readonly<{
  API_HOST: string;
  WS_HOST: string;
  KB_CHATBOT_HOST?: string;
  LOCAL_WEBCMS_PREVIEW_HOST?: string;
  /** In development mode, these feature flags are treated as if the user doesn't have them */
  FEATURE_FLAGS_REMOVED?: FeatureFlag[];
  /** In development mode, these feature flags are treated as if the user has them */
  FEATURE_FLAGS_ADDED?: FeatureFlag[];
  /** In development mode, these permissions are treated as if the user doesn't have them */
  PERMISSIONS_REMOVED?: Permission[];
  /** In development mode, these permissions are treated as if the user has them */
  PERMISSIONS_ADDED?: Permission[];
}>;

export const loadConfig = async () => {
  let response: Response;

  if (process.env.NODE_ENV === 'development') {
    response = await fetch(OVERRIDE_CONFIGURATION_FILE);
    if (!response.ok) {
      response = await fetch(CONFIGURATION_FILE);
    }
  } else {
    response = await fetch(CONFIGURATION_FILE);
  }

  const config: Config = await response.json();
  return config;
};
